import React from 'react';
// import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

import Layout from '../components/Layout';
import SEO from '../components/SEO';
import { WhiteBlock } from '../styles/WhiteBlock';

const CreateWorkspaces = () => (
  <Layout>
    <SEO title="Home" />
    <div className="db-area-main">
      <div className="db-container">
        <a href="#!" className="db-back-link button-chevron-left">
          <img src="/img/chevron-left.svg" alt="chevron" /> Back to the
          dashboard
        </a>
        <div className="flex-row">
          <div className="col col-4 offset-4">
            <WhiteBlock style={{ maxWidth: 385 }}>
              <div className="white-block-body">
                <h2
                  className="db-heading text-center"
                  style={{ marginBottom: 10 }}>
                  Create Workspace
                </h2>
                <p className="subhead text-center">
                  Need to work together with your team on project? Create a team
                  to get started.
                </p>

                <div className="workspace-features-block">
                  <div className="flex-row no-margin">
                    <img src="/img/user-group.svg" alt="" />
                    <p>5 members included </p>
                  </div>
                  <div className="flex-row no-margin">
                    <img src="/img/customised-template.svg" alt="" />
                    <p>Get all customised story template</p>
                  </div>
                  <div className="flex-row no-margin">
                    <img src="/img/domain.svg" alt="" />
                    <p>1 custom domain </p>
                  </div>
                  <div className="flex-row no-margin">
                    <img src="/img/unlimited-story.svg" alt="" />
                    <p>Unlimited story view</p>
                  </div>
                </div>
                <Link
                  className="button button-block"
                  style={{ marginTop: 20 }}
                  to="/setup-workspace/">
                  Create Team
                </Link>
              </div>
            </WhiteBlock>
          </div>
        </div>
      </div>
    </div>
  </Layout>
);

export default CreateWorkspaces;
